import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "desktop-body-l text-white-light py-2 mb-8 text-left"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "w-full h-full" }

import { computed, onMounted, ref, toRefs, watch } from 'vue';
import LazyImage from '../LazyImage.vue';
import { useScreenSize } from '../../core';
import Carousel from '../carousel/BaseCarousel.vue';
import { NextIconHtml, PrevIconHtml } from '../../constant/icons';
import CustomCarousel from './CustomCarousel.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageLightbox',
  props: {
    sliderData: {},
    currentSlide: {}
  },
  setup(__props: any) {

const props = __props;
const { sliderData, currentSlide } = toRefs(props);
const timelineCarouselConfig = computed(() => {
  return {
    settings: {
      itemsToShow: isLg.value ? 12 : 4,
    },
    slides: sliderData.value,
    slidesForNavigation: 1,
  };
});

const carouselConfig = computed(() => {
  return {
    settings: {
      itemsToShow: 1,
    },
    slides: sliderData.value,
    navigationActive: true,
    slidesForNavigation: 1,
    nextIconHtml: NextIconHtml,
    previousIconHtml: PrevIconHtml,
  };
});

const { isLg } = useScreenSize();
const selectedSlide = ref(0);

const setSlide = (index: number) => {
  selectedSlide.value = index;
};

watch(currentSlide, () => {
  setSlide(currentSlide.value);
});

const setSlideIndex = (item) => {
  const index = sliderData.value.findIndex(
    (data) => data.asset_value === item.asset_value
  );
  setSlide(index);
};

onMounted(() => {
  setSlide(currentSlide.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CustomCarousel, _mergeProps(carouselConfig.value, {
      ref: "custom-carousel",
      "selected-slide": selectedSlide.value,
      "onUpdate:currentSlide": _cache[0] || (_cache[0] = (slideIndex) => setSlide(slideIndex))
    }), {
      "main-slide": _withCtx(({ item, index }) => [
        _createElementVNode("div", {
          class: "carousel__item disabled-image-pointer",
          onClick: ($event: any) => (setSlide(index))
        }, [
          (item?.caption)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(item?.caption), 1))
            : _createCommentVNode("", true),
          (item?.asset_value)
            ? (_openBlock(), _createBlock(LazyImage, {
                key: 1,
                class: "aspect-video",
                src: item.asset_value,
                alt: item.alt_tag,
                "is-neighborhood-image": false
              }, null, 8, ["src", "alt"]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1)
      ]),
      _: 1
    }, 16, ["selected-slide"]),
    _createVNode(Carousel, _mergeProps(timelineCarouselConfig.value, {
      "selected-slide": selectedSlide.value,
      "delay-in-transition": 1000,
      class: ["masonry-thumbnail", { notranslate: timelineCarouselConfig.value.slides.length < 11 }]
    }), {
      default: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["carousel__item h-12 md:h-20 w-full rounded overflow-hidden px-1", { 'border-white-light': item.index === selectedSlide.value }]),
          onClick: ($event: any) => (setSlideIndex(item))
        }, [
          _createElementVNode("div", _hoisted_4, [
            (item && item?.asset_value)
              ? (_openBlock(), _createBlock(LazyImage, {
                  key: 0,
                  class: "h-full w-full object-cover rounded",
                  src: item.asset_value + '?io=transform:fill,width:200',
                  alt: item.alt_tag,
                  "is-neighborhood-image": false
                }, null, 8, ["src", "alt"]))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_3)
      ]),
      _: 1
    }, 16, ["selected-slide", "class"])
  ]))
}
}

})